import { render, staticRenderFns } from "./HalfPieChart.vue?vue&type=template&id=0b70c7ca&scoped=true"
import script from "./HalfPieChart.vue?vue&type=script&lang=js"
export * from "./HalfPieChart.vue?vue&type=script&lang=js"
import style0 from "./HalfPieChart.vue?vue&type=style&index=0&id=0b70c7ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b70c7ca",
  null
  
)

export default component.exports